module.exports = __webpack_public_path__ + "media/images/smart_phone/img_support-9fe3aff0918a0d24fca3c36a46eb4993.png";